// extracted by mini-css-extract-plugin
module.exports = {"expandingVoid":"ExpandingRow_expandingVoid__2tNzf","grow":"ExpandingRow_grow__gE3sX","scalingContents":"ExpandingRow_scalingContents__O_tMk","scaled":"ExpandingRow_scaled__2s9Oo"};